import * as React from 'react';
const SvgChatPrefill = (props) => (
  <svg
    width={22}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
      stroke="url(#paint0_linear_2652_483)"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7221 7.26596C14.2107 7.10312 14.4549 7.02169 14.6174 7.07962C14.7587 7.13003 14.87 7.24127 14.9204 7.38263C14.9783 7.54507 14.8969 7.78935 14.734 8.27789L13.2465 12.7405C13.2001 12.8797 13.1769 12.9492 13.1374 13.007C13.1024 13.0582 13.0582 13.1024 13.007 13.1374C12.9492 13.1769 12.8797 13.2001 12.7405 13.2465L8.27789 14.734C7.78935 14.8969 7.54507 14.9783 7.38263 14.9204C7.24127 14.87 7.13003 14.7587 7.07962 14.6174C7.02169 14.4549 7.10312 14.2107 7.26596 13.7221L8.75351 9.25947C8.79989 9.12033 8.82308 9.05076 8.8626 8.99299C8.8976 8.94182 8.94182 8.8976 8.99299 8.8626C9.05076 8.82308 9.12033 8.79989 9.25947 8.75351L13.7221 7.26596Z"
      stroke="url(#paint1_linear_2652_483)"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2652_483"
        x1={11}
        y1={1}
        x2={11}
        y2={21}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8A90FF" />
        <stop offset={1} stopColor="#B15FDA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2652_483"
        x1={11}
        y1={1}
        x2={11}
        y2={21}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8A90FF" />
        <stop offset={1} stopColor="#B15FDA" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgChatPrefill;
